import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

import useAnimatedTheme from "$src/core/hooks/use-animated-theme";

const stylesheet = StyleSheet.create(({ spacing, border, colors }) => ({
  container: {
    marginBottom: spacing(24),
    gap: spacing(8),
    justifyContent: "flex-start",
    alignItems: "center",
    alignSelf: "flex-start",
    flexDirection: "row",
  },
  iconContainer: {
    padding: spacing(4),
    borderColor: colors.borderDefault,
    borderWidth: border.widths.md,
    borderRadius: border.radius.full,
  },
  icon: {
    color: colors.foregroundDefault,
    width: spacing(12),
    height: spacing(12),
  },
}));

export const useAnimatedStyles = ({
  isFocused,
}: {
  isFocused: SharedValue<boolean>;
}) => {
  const theme = useAnimatedTheme();

  const iconContainerStyle = useAnimatedStyle(() => {
    const { foregroundDefault, borderDefault } = theme.value.colors;
    return {
      borderColor: isFocused.value ? foregroundDefault : borderDefault,
    };
  });

  return {
    iconContainerStyle,
  };
};

export default stylesheet;
